<div class="layout-full">
    <div class="container login-container">
        <div class="main">
            <router-outlet></router-outlet>
    
            <div class="left-small-div"></div>
            <div class="fade-left-small-div1"></div>
            <div class="fade-left-small-div2"></div>
            <div class="right-small-div"></div>
            <div class="fade-right-small-div1"></div>
        </div>
      </div>
</div>
